'use client'

import { useRouter } from 'next/navigation'
import { useSessionExpired } from '@/hooks/business/auth/useSessionExpired'
import { useSessionSync } from '@/hooks/business/auth/useSessionSync'
import GSwal from '~/components/GSwal'

/**
 * Sessão do cliente na casca: confere a sessão a cada navegação (`useSessionSync`) e, quando ela expira, avisa e manda
 * para o login. Era o papel do AuthHandlerContext.
 */
export const SessionWatcher: React.FC = () => {
    const router = useRouter()

    // O ouvinte vem antes da conferência: os efeitos rodam na ordem, e a conferência da montagem já pode expirar.
    useSessionExpired((message) => {
        GSwal.fire({ icon: 'warning', title: 'Sua sessão expirou!', text: message }).then(() =>
            router.replace('/login'),
        )
    })
    useSessionSync()

    return null
}
